import type {
  PickType,
  UiMessageChunkDto,
  UserInputNodeConfig,
} from "@intelligems/ig-types";

/**
 * Type guard processor for workflow stream parts
 * Provides static utility methods for type checking
 */
export class UiMessageChunkTypeGuardProcessor {
  static isTextStartChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "text-start"> {
    return part.type === "text-start";
  }

  static isTextDeltaChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "text-delta"> {
    return part.type === "text-delta";
  }

  static isDeprecatedTextChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "text"> {
    return part.type === "text";
  }

  static isTextEndChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "text-end"> {
    return part.type === "text-end";
  }

  // static isToolInputDeltaStreamPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "tool-input-delta"> {
  //   return part.type === "tool-input-delta";
  // }
  //
  // static isToolOutputDeltaStreamPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "tool-output-available"> {
  //   return part.type === "tool-output-available";
  // }

  static isReasoningDeltaChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "reasoning-delta"> {
    return part.type === "reasoning-delta";
  }

  static isReasoningStartChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "reasoning-start"> {
    return part.type === "reasoning-start";
  }

  static isDeprecatedReasoningChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "reasoning"> {
    return part.type === "reasoning";
  }

  static isReasoningEndChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "reasoning-end"> {
    return part.type === "reasoning-end";
  }

  static isToolInputStartChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "tool-input-start"> {
    return part.type === "tool-input-start";
  }

  static isToolInputDeltaChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "tool-input-delta"> {
    return part.type === "tool-input-delta";
  }

  static isToolInputAvailableChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "tool-input-available"> {
    return part.type === "tool-input-available";
  }

  static isToolInputErrorChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "tool-input-error"> {
    return part.type === "tool-input-error";
  }

  static isToolOutputAvailableChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "tool-output-available"> {
    return part.type === "tool-output-available";
  }

  static isToolOutputErrorChunk(
    part: UiMessageChunkDto
  ): part is PickType<UiMessageChunkDto, "tool-output-error"> {
    return part.type === "tool-output-error";
  }

  static isChoicesUserInput(
    userInput: UserInputNodeConfig
  ): userInput is PickType<UserInputNodeConfig, "choice"> {
    return userInput.type === "choice";
  }

  //
  // static isFullReasoningPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "reasoning"> {
  //   return part.type === "reasoning";
  // }
  //
  // static isStartPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "start"> {
  //   return part.type === "start";
  // }
  //
  // static isFinishPart(
  //   part: UiMessageChunkDto
  // ): part is PickType<UiMessageChunkDto, "finish"> {
  //   return part.type === "finish";
  // }
}
